import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import AccountInfoPanel from "@/trust-admin-app/components/trust-admin-rhs-header/account-info-panel/index.vue";
import NavigationBar from "@/shared/components/navigation-bar/index.vue";
import { NavItem, NavItemStatusID } from "@/shared/components/navigation-bar/navigation-item";
import { RouteN } from "@/trust-atcs-app/constants/router-name";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import StdPageLayout from "../std-page-layout/index.vue";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { AuthorizedUser } from '@/trust-atcs-app/models/authorized-user';
import { AuthenticationStatusType } from '@/trust-atcs-app/modules/authentication/authentication-status';
import { IDLESessionManager } from '@/trust-atcs-app/modules/session/idle-session-manager';
import store from '../../store';
import { RoleType } from "@/trust-atcs-app/models/user";
import { TrustAPI } from "@/shared/modules/trust-api";

Vue.registerHooks(['beforeRouteEnter']);
@Options({
  components: {
    NavigationBar,
    AccountInfoPanel,
    LoadingSpinner,
    ErrorIndicator,
    StdPageLayout,
  }
})
export default class AtcsMain extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private isFixHeader = true;

  private errorLoadingData = false;
  private loadingData = true;

  private idleSessionMgr: IDLESessionManager = new IDLESessionManager();

  private navItems: NavItem[] = [
    new NavItem('Home', RouteN.ATCS.Home.n, undefined, true, NavItemStatusID.Current),
    new NavItem(
      'Navigation 2',
      RouteN.ATCS.Home.n,
      undefined,
      // this.$accessPermitted(this.usrAcct.user.roles, RouteN.ATCS.Home.r),
      // NavItemStatusID.NotCurrent
    ),
    new NavItem(
      'Navigation 2',
      RouteN.ATCS.Home.n,
      undefined,
      // this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.Routines.r),
      // NavItemStatusID.NotCurrent
    ),

  ];

  // @Watch('$route')
  // private onRouteChange(): void {
  //   if (this.userAccount.user?.isPrincipal && this.userAccount.user?.impersonatedLawId) {

  //   };
  // }

  beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    const c1: boolean = to.matched.some((record) => record.meta.requiresAuth);
    const c2: boolean = (store.getters.getUserAccount as AuthorizedUser)
      .authenticationStatus === AuthenticationStatusType.AppAccessPermitted;
    c1 && !c2 ? next({ name: RouteN.ATCS.LoginPage.n, query: { redirect: to.fullPath } }) : next();
  }

  beforeUnmount(): void {
    this.idleSessionMgr.stop();
  }

  created(): void {
    this.idleSessionMgr.run(this.idleSessionTimeoutCallback);
    // this.initImpersonatedUser();
    this.pageRedirection();
  }

  private pageRedirection(): void {
    let pageName = { name: RouteN.ATCS.DashboardMain.n };
    // this.userAccount.user.roles.forEach((x) => {
    //   switch (x) {
    //     case RoleType.Tester:
    //       if (this.userAccount.user.impersonatedLawId) {
    //         pageName = { name: RouteN.ATCS.Dashboard.n };
    //       } else {
    //         pageName = { name: RouteN.ATCS.ImpersonateUser.n };
    //       }
    //       break;
    //     case RoleType.Principal:
    //     case RoleType.KeyContact:
    //     case RoleType.TrustCoordinators:
    //     case RoleType.ToBeExternalExaminer:
    //     case RoleType.ExternalExaminer:
    //       pageName = { name: RouteN.ATCS.Dashboard.n };
    //   }
    // });

    if (this.userAccount.user.isTester && !this.userAccount.user.impersonatedLawId) {
      pageName = { name: RouteN.ATCS.ImpersonateUser.n };
    } else {
      // console.log('dashboard');
      pageName = { name: RouteN.ATCS.DashboardMain.n };
    }

    this.$router.replace(pageName);
  }

  // private async initImpersonatedUser(): Promise<void> {
  //   if (this.userAccount.user?.impersonatedLawId == null) {
  //     store.dispatch('setImpersonatedUser', null as any);
  //   } else {
  //     try {
  //       const resp: any = await this.apiService.LawIdApi?.apiV2LawIdGetLawIdUsersPost(
  //         { lawId: this.userAccount.user.impersonatedLawId }
  //       );
  //       store.dispatch('setImpersonatedUser', resp.data.data[0] as LawIdUser);
  //     } catch {
  //       store.dispatch('setImpersonatedUser', null as any);
  //     }
  //   }
  // }

  private idleSessionTimeoutCallback(): void {
    this.$router.push({ name: RouteN.ATCS.LogoutPage.n });
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }  
}

